import React from 'react';

const LoadingSpinner = ({ message = 'Cargando...', fullScreen = false }) => {
  if (fullScreen) {
    return (
      <div className='fixed inset-0 flex items-center justify-center z-50'>
        <div className='rounded-full p-4'>
          <div className='animate-spin rounded-full h-16 w-16 border-b-2 border-indigo-600'></div>
        </div>
      </div>
    );
  }

  return (
    <div className='flex flex-col items-center justify-center py-12'>
      <div className='animate-spin rounded-full h-12 w-12 border-b-2 border-indigo-600'></div>
      <p className='mt-4 text-sm text-slate-600'>{message}</p>
    </div>
  );
};

export default LoadingSpinner;
